import React from "react"

import InfiniteLooper from "./Looper"
import RichText from "./richText/Parser"

function LogosGallery({ component }) {
  const { logos, richtitle, isDefiling, speed } = component

  const makeLogoRow = (
    <div className=" flex flex-wrap items-center justify-around -mb-4 -mx-2 `">
      {logos &&
        logos.map((logo, key) => {
          return (
            logo?.localFile?.childImageSharp?.gatsbyImageData?.images
              ?.sources[0]?.srcSet && (
              // eslint-disable-next-line react/no-array-index-key
              <span key={logo.altText + key}>
                <img
                  className="inline-block flex-shrink-0 mb-4 px-2 max-w-[175px] max-h-[80px]"
                  srcSet={
                    logo.localFile.childImageSharp?.gatsbyImageData.images
                      .sources[0].srcSet
                  }
                  alt={logo.altText}
                />
              </span>
            )
          )
        })}
    </div>
  )
  const renderLogos = () => {
    if (isDefiling)
      return (
        <InfiniteLooper speed={speed || "20"} direction="left">
          {makeLogoRow}
        </InfiniteLooper>
      )
    return makeLogoRow
  }
  return (
    <div className="pt-12">
      <div className="px-4 pt-8 pb-8 mx-auto max-w-7xl sm:pt-16 sm:px-6 lg:px-8">
        <div className="text-center">
          {richtitle && (
            <RichText option="sectionTitle" stringHtml={richtitle} />
          )}
        </div>
      </div>
      <div className="relative">
        <div className="px-4 pb-16 mx-auto sm:px-6 max-w-7xl sm:pb-24">
          {renderLogos()}
        </div>
      </div>
    </div>
  )
}

export default LogosGallery
